import React from 'react';
import { Text } from '@upsales/components';
import BemClass from '@upsales/components/Utils/bemClass';

import './UnreadBadge.scss';

interface UnreadBadgeProps {
	count: number;
	size?: 'sm' | 'lg';
	onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
	spacing?: React.ComponentProps<typeof Text>['spacing'];
}

const UnreadBadge: React.FC<UnreadBadgeProps> = ({ count, size = 'sm', onClick, spacing }) => {
	if (count <= 0) {
		return null;
	}

	const classes = new BemClass('UnreadBadge');
	const displayCount = count > 99 ? '99+' : count;

	return (
		<Text
			spacing={spacing}
			className={classes.mod({ [size]: true }).b()}
			size={size === 'sm' ? 'xs' : 'sm'}
			color="white"
			onClick={onClick}
		>
			{displayCount}
		</Text>
	);
};

export default UnreadBadge;
